exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.uploader .el-upload:hover{border-color:#409eff}.uploader-icon{font-size:28px;color:#8c939d;line-height:178px;text-align:center}.avatar,.uploader-icon{width:178px;height:178px}.avatar{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ec98430","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/companies/logo.vue
// module id = XSsn
// module chunks = 0